import React from "react";

import { ConfirmationResult, UserInfo } from "firebase/auth";

import { useMutation } from "@apollo/client";

import { useApolloClient } from "@apollo/client";

/** components */
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

/** services */
import { login, logout } from "../../../services/auth";

/** context */
import { useSettings } from "../../../context/settings";

/** QUERIES & MUTATIONS */
import CREATE_USER from "../../../provider/Users/mutation";

/** utils */
import { getGraphsqErros, errorLoginPhoneFirebase, maskPhone, clearMask, sleep } from "../../../utilities/functions";

import { PLANS } from "../../../provider/Plans/query";
import { useLocation, useParams } from "react-router-dom";
import { FRANCHISE } from "../../../provider/Franchises/query";
import { useUser } from "../../../context/users";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import UPLOAD_FILE from "../../../provider/Upload/mutation";
import { CREATE_PASSENGER } from "../../../provider/Passengers/mutation";

const Window: any = global.window;

export const Register = (props: any) => {
  const settings = useSettings();
  const apollo = useApolloClient();

  const user = useUser();

  const franchise_id = user?.getUser()?.franchise?.id;
  const acting_region_id = user?.getUser()?.actingRegion?.id;

  const location = useLocation();

  const params = useParams();

  const [uploadFile] = useMutation(UPLOAD_FILE);
  const [createPassenger] = useMutation(CREATE_PASSENGER);

  const [loading, setLoading] = React.useState<boolean>(false);
  const [loadFranchise, setLoadFranchise] = React.useState<boolean>(true);
  const [submitted, setSubmitted] = React.useState<boolean>(false);

  const [name, setName] = React.useState("");
  const [cpf, setCpf] = React.useState("");
  const [imagePath, setImagePath] = React.useState("");

  const [banner, setBanner] = React.useState('assets/layout/images/pages/login-onlight.png');
  const [logo, setLogo] = React.useState('assets/layout/images/logo-light.png');
  const [appName, setAppName] = React.useState('Vamos CAP');

  const upload = (e: FileUploadHandlerParam, key: string) => {
    const file = e.files;

    if (!file || file.length <= 0) return;

    uploadFile({
      variables: {
        file: file[0],
      },
    })
      .then(res => {
        setImagePath(res.data.singleUpload);
      })
      .catch(error => {
        settings?.setErrorMessage(getGraphsqErros(error));
        settings?.setVisibleError(true);
      });
  };

  const sendRegister = () => {
    setSubmitted(true);

    if (name === '' || cpf === '' || imagePath === '') return;

    setLoading(true);
    
    const data = {
      name,
      phone: user?.getUser()?.phone,
      cpf,
      image_path: imagePath,
      user_id: Number(user?.getUser()?.id) | 0, 
    }

    createPassenger({ variables: { data } })
      .then(async response => {
        if (response.data && response.data.createPassenger) {
          logout();
          setTimeout(() => {
            document.location.href = "/callcenter/" + franchise_id;
            setLoading(false);
          }, 10000);
          settings.setErrorMessage("Solicite a liberação de seu acesso para o administrador.");
          settings.setVisibleError(true);
        } else {
          settings?.setErrorMessage("Oops!", "Não foi possível enviar seus dados, verifique as informações e tente novamente");
          settings?.setVisibleError(true);
          setLoading(false);
        }
      })
      .catch(async e => {
        settings?.setErrorMessage(getGraphsqErros(e));
        settings?.setVisibleError(true);
        setLoading(false);
      });
  }

  React.useEffect(() => {
    const franchise = user?.getUser()?.franchise;
    if (franchise) {
      if (franchise.banner_path && franchise.banner_path !== '') setBanner(franchise.banner_path);
      if (franchise.logo_path && franchise.logo_path !== '') setLogo(franchise.logo_path);
      if (franchise.name && franchise.name !== '') setAppName(franchise.name);
    }
  }, []);

  return (
    <div className="login-body">
      <div className="login-image">
        <img src={banner} alt={appName} />
      </div>

      <div className="login-panel p-fluid" style={{padding: 10}}>
      <form
        onSubmit={e => {
          e.preventDefault();
          sendRegister();
        }}>
        <div className="flex flex-column">
          <div className="flex align-items-center mb-6 logo-container">
            <img
              src={logo}
              className="login-logo"
              alt="login-logo"
            />
            <h3 className="ml-2">{appName}</h3>
          </div>
          <div className="form-container">
            <div className="field text-left">
              <label className="mb-3" style={{fontSize: '2rem'}}>Complete seu Cadastro</label>
            </div>
          </div>
          <div className="form-container">
            <div className="field text-left">
              <span className="p-input-icon-left">
                <i className="pi pi-user"></i>
                <InputText
                  autoComplete="new-password"
                  type="text"
                  placeholder="Nome Completo"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  autoFocus
                  className={classNames("pt-3 pb-3 ", { "p-invalid": submitted && !name })}
                />
              </span>
              {submitted && !name && <small className="p-invalid">Nome completo é obrigatório.</small>}
            </div>
          </div>
          <div className="form-container">
            <div className="field text-left">
              <span className="p-input-icon-left">
                <i className="pi pi-id-card"></i>
                <InputText
                  autoComplete="new-password"
                  type="text"
                  placeholder="CPF/CNPJ"
                  value={cpf}
                  onChange={e => setCpf(e.target.value)}
                  autoFocus
                  className={classNames("pt-3 pb-3 ", { "p-invalid": submitted && !cpf })}
                />
              </span>
              {submitted && !cpf && <small className="p-invalid">CPF/CNPJ é obrigatório.</small>}
            </div>
          </div>
          <div className="form-container">
            <div className="field text-left">
              <span className="p-input-icon-left">
                <label className="mb-3" style={{
                  fontSize: '1rem',
                  color: submitted && !imagePath ? 'red' : 'white',
                }}>
                  Selecione uma imagem
                </label>
                <FileUpload
                  chooseLabel="Procurar"
                  auto
                  name="file"
                  customUpload={true}
                  uploadHandler={e => upload(e, "icon_path")}
                  accept="image/*"
                  maxFileSize={1000000}
                  style={{width: '22rem'}}
                />
              </span>
              {submitted && !imagePath && <small className="p-invalid">Imagem é obrigatório.</small>}
            </div>
          </div>
          <div className="button-container">
            <Button type="submit" disabled={loading} label={loading ? "Enviando cadastro..." : "CADASTRAR"} className="p-3" />
          </div>
        </div>
      </form>
      </div>
    </div>
  );
};
